import React from "react";
export const SwapperSvg = () => {
  return (
    <svg
      style={{ width: "2.4rem", h: "2.4rem" }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 10H15"
        stroke="#475CED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 14L10.9985 16"
        stroke="#475CED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 14H9"
        stroke="#475CED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0005 10L13.002 8"
        stroke="#475CED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.06836 20.7809C5.30694 20.7809 3.06836 18.5423 3.06836 15.7809L3.06836 7.78088C3.06836 5.01946 5.30694 2.78088 8.06837 2.78089L16.0684 2.78089C18.8298 2.78089 21.0684 5.01947 21.0684 7.78089L21.0684 15.7809C21.0684 18.5423 18.8298 20.7809 16.0684 20.7809L8.06836 20.7809Z"
        stroke="#475CED"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
